import React, { useEffect, useState } from "react";
import { Youtube, Play } from "lucide-react";
import api from "@/lib/api";

const CHANNEL = "https://www.youtube.com/@convergedsecurity";

export const MasterclassVideos = ({ limit = 3, title = "Latest masterclasses", className = "" }) => {
  const [videos, setVideos] = useState([]);
  const [playing, setPlaying] = useState(null);
  useEffect(() => {
    api.get("/youtube/latest", { params: { limit } }).then((r) => setVideos(r.data || [])).catch(() => {});
  }, [limit]);
  if (!videos.length) return null;
  return (
    <section className={className} data-testid="masterclass-videos">
      <div className="flex items-end justify-between flex-wrap gap-3 mb-4">
        <div>
          <div className="eyebrow mb-1 inline-flex items-center gap-1.5"><Youtube size={13} className="text-red-600"/> CSI Masterclasses</div>
          <h2 className="font-display text-2xl sm:text-3xl">{title}</h2>
        </div>
        <a href={CHANNEL} target="_blank" rel="noreferrer" className="chip inline-flex items-center gap-1.5 text-sm" data-testid="masterclass-channel-link">
          <Youtube size={14} className="text-red-600"/> View all on YouTube
        </a>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {videos.map((v) => (
          <article key={v.id} className="rounded-2xl overflow-hidden border border-[var(--border-warm)] bg-white" data-testid={`masterclass-${v.id}`}>
            <div className="relative aspect-video bg-black">
              {playing === v.id ? (
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube-nocookie.com/embed/${v.id}?autoplay=1&rel=0`}
                  title={v.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button onClick={() => setPlaying(v.id)} className="group absolute inset-0 w-full h-full" aria-label={`Play ${v.title}`} data-testid={`masterclass-play-${v.id}`}>
                  <img src={v.thumbnail} alt={v.title ? `Masterclass: ${v.title}` : "CSI masterclass video"} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" loading="lazy"/>
                  <span className="absolute inset-0 grid place-items-center">
                    <span className="w-14 h-14 rounded-full bg-red-600 text-white grid place-items-center shadow-lg group-hover:scale-110 transition-transform"><Play size={22} fill="currentColor"/></span>
                  </span>
                </button>
              )}
            </div>
            <div className="p-3">
              <div className="text-sm font-semibold leading-snug line-clamp-2">{v.title}</div>
              <div className="text-xs text-zinc-500 mt-1">{new Date(v.published).toLocaleDateString()}</div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
